import {apiRoutes} from "@/lib/routes/api";
import {backendAPIRoutes} from "@/lib/routes/backend";
import {axiosBackendAPI, axiosClientAPI} from "@/lib/axios";
import { v2Api } from "@/lib/api";

export const PlayerService = {
    create: async (data: {
        username: string;
        email: string;
        password: string;
        password_confirm: string;
        first_name?: string;
        last_name?: string;
        phone_number?: string;
        team_id?: number | null;
        is_active?: boolean;
        is_verified?: boolean;
        is_staff?: boolean;
        is_superuser?: boolean;
    }) => {
        const res = await axiosClientAPI.post(apiRoutes.dashboard.users.list, data);
        return res.data;
    },
    getPlayerById: async (id: string) => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.get(backendAPIRoutes.dashboard.users.detail(id));
            return res.data;
        }
        const res = await axiosClientAPI.get(apiRoutes.users.detail(id));
        return res.data;
    },

    getPlayerReports: async (playerId: string) => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.get(backendAPIRoutes.dashboard.users.reports(playerId));
            return res.data;
        }
        return v2Api.users.report(playerId);
    },

    changePassword: async (userId: string, data: { password: string; confirm_password: string }) => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.post(backendAPIRoutes.dashboard.users.changePassword(userId), data);
            return res.data;
        }
        const res = await axiosClientAPI.post(apiRoutes.users.changePassword(userId), data);
        return res.data;
    },

    updateProfile: async (
        userId: string, 
        data: {
            username?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            avatar_id?: number | null;
            bio?: string;
            profile?: {
                date_of_birth?: string | null;
                gender?: string | null;
                job_title?: string | null;
                company?: string | null;
                department?: string | null;
            };
        }
    ) => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.patch(backendAPIRoutes.dashboard.users.update(userId), data);
            return res.data;
        }
        const res = await axiosClientAPI.patch(apiRoutes.users.update(userId), data);
        return res.data;
    },

    adminQuickUpdate: async (
        userId: string,
        data: {
            username?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            avatar_id?: number | null;
            is_active?: boolean;
            is_verified?: boolean;
            is_staff?: boolean;
            is_superuser?: boolean;
            team_id?: number;
        },
    ) => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.post(backendAPIRoutes.dashboard.users.update(userId), data);
            return res.data;
        }
        const res = await axiosClientAPI.post(apiRoutes.users.adminUpdate(userId), data);
        return res.data;
    },

    getAvatarList: async () => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.get(backendAPIRoutes.avatar.list);
            return res.data;
        }
        const res = await axiosClientAPI.get(apiRoutes.avatar.list);
        return res.data;
    }
};
